import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import { Repeat } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import SlotPicker from "../../components/SlotPicker/SlotPicker";
import SkeletonCard from "../../components/Loaders/SkeletonCard";
import { fetchAvailabilitiesByScheduleId, resheduleBooking } from "../../redux/actions/apiActions";
import { showAlert } from "../../redux/actions/commonActions";
import { setShowLoginForm } from "../../redux/actions/authActions";
import moment from "moment-timezone";

const BookingReschedule = () => {
    const userData = useSelector(state => state.auth.userData);
    const bookingDetails = useSelector(state => state.api.bookingDetails);
    const availabilities = useSelector(state => state?.api?.availabilities[bookingDetails?.tempServiceId]);
    const availabilitiesLoading = useSelector(state => state?.api?.availabilitiesLoading[bookingDetails?.id]);
    const dispatch = useDispatch();

    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [filteredAvailabilities, setFilteredAvailabilities] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);

    const [selectedSlot, setSelectedSlot] = useState(null);

    const onSelectSlot = (slot) => {
        setSelectedSlot(prev => prev?.startSec !== slot?.startSec ? slot : null)
    }

    const closeRescheduleModal = () => {
        setShowRescheduleModal(false);
    }
    const onConfirmReschedule = async () => {
        if (selectedSlot?.id && bookingDetails?.id) {
            let payload = {
                eventId: bookingDetails?.id,
                newAvailabilityId: selectedSlot?.id
            }
            const status = await dispatch(resheduleBooking(payload));
            if (status) {
                setShowRescheduleModal(false);
            }
        }

    }

    const handleButton = () => {
        const isAuthorisedUser = userData?.id &&
            (
                userData?.id === bookingDetails?.customerId ||
                userData?.email === bookingDetails?.customerEmail ||
                userData?.telephone === bookingDetails?.customerPhoneNumber
            );

        if (isAuthorisedUser) {
            setShowRescheduleModal(true)
        } else {
            if (userData?.id) {
                dispatch(showAlert("error", "You are not allowed to rescehdule this booking. Please login using Email/Phone number that used to book this appointment."))
            } else {
                dispatch(setShowLoginForm(true));
            }
        }
    }

    useEffect(() => {
        if (availabilities) {
            setIsRefreshing(true);
            let filteredAvailabilities_ = availabilities.filter(a => a.startSec !== bookingDetails.startSec);
            //Disable slots based on multiBooking conditions
            if (bookingDetails?.multiBooking) {
                const horizonDays = bookingDetails?.multiBooking?.horizonDays ?? 2;
                const gapMinutes = bookingDetails?.multiBooking?.gapMinutes ?? 0;
                const firstChildSlot = [...(bookingDetails?.subBookings ?? [])].sort((a, b) => a.startSec - b.startSec)?.[0]?.startSec;
                const parentSlot = bookingDetails?.parentBooking?.startSec ?? 0;
                filteredAvailabilities_ = filteredAvailabilities_.map(item => {
                    let disabled = false;
                    if (bookingDetails.subBookings?.length) {
                        if (firstChildSlot && item.startSec > (firstChildSlot - (gapMinutes * 60))) {
                            disabled = true;
                        }
                    }
                    if (bookingDetails?.parentBooking?.id) {
                        if (parentSlot && ((item.startSec < (parentSlot + (gapMinutes * 60))) || (item.startSec > (parentSlot + (horizonDays * 86400))))) {
                            disabled = true;
                        }
                    }
                    return { ...item, disabled };
                });
            }
            setFilteredAvailabilities(filteredAvailabilities_)
            setTimeout(() => setIsRefreshing(false), 500)
        }
    }, [availabilities])

    useEffect(() => {
        if (showRescheduleModal) {
            setIsRefreshing(true);
            dispatch(fetchAvailabilitiesByScheduleId(bookingDetails?.tempServiceId))
            //setTimeout(() => setIsRefreshing(false), 1000)
        }
    }, [showRescheduleModal])

    const isRechduleAllowedNow = useMemo(
        () => {
            if (bookingDetails?.modificationAllowedUntil && moment().isAfter(moment.unix(bookingDetails?.modificationAllowedUntil))) {
                return true;
            }
            return false;
        }, [bookingDetails]
    )


    if (!bookingDetails?.id) {
        return <></>
    }
    return (
        <>
            <Button variant="outlined" sx={{ borderRadius: 5, gap: 1 }} onClick={handleButton} disabled={isRechduleAllowedNow}>
                <Repeat /> Reschedule
            </Button>
            <Dialog
                open={showRescheduleModal}
                onClose={closeRescheduleModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { borderRadius: 3, minHeight: '60%' } }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
                    <Typography variant="overline" >Reschedule Booking</Typography>
                </DialogTitle>
                <DialogContent>
                    {availabilitiesLoading || isRefreshing ?
                        <SkeletonCard cardType="availabilities" />
                        :
                        <SlotPicker
                            availabilities={filteredAvailabilities}
                            onSelectSlot={onSelectSlot}
                            selectedSlotIds={selectedSlot?.id}
                            timezoneId={bookingDetails?.timezoneId}
                        />
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeRescheduleModal}>Cancel</Button>
                    <Button onClick={onConfirmReschedule} autoFocus disabled={!selectedSlot}>
                        Reschedule
                    </Button>
                </DialogActions>
            </Dialog>
        </>


    )
}

export default BookingReschedule;